import {
    get,
    post, del, put
} from './request'


import { serverApiUrl } from '../config/server';

let projectPageNo = 1;
let projectSize = 20;
let myProject = [];
/**
 * 获取项目列表
 * @param {string} groupId 
 * @returns {Promise<any>}
 */
export const getProject = async (groupId, cb) => {
    const response = await get(`${serverApiUrl}/${groupId}/project/myProject`, {
        PageNo: projectPageNo,
        PageSize: projectSize
    },{}, { cache: false });
    let data = response.data;
    if (!data.success) {
        return cb(data);
    }
    myProject = [...myProject, ...data.data];
    data.data = myProject;
    if (projectPageNo < data.totalPage) {
        projectPageNo++;
        getProject(groupId, cb);
    } else {
        projectPageNo = 1;
        myProject = [];
        cb && cb(data);
    }
    return data;
}

let devicePageNo = 1;
let devicePageSize = 20;
let mydeivdevice = [];

/**
 * 获取项目下的所有设备
 * @param {string} groupId 阻止id
 * @param {string} projectId 项目id
 * @param {string} cb 回调函数
 * @returns {Promise<any>}
 */
export const getProjectDevices = async (groupId, projectId, cb) => {
    const result = await get(`api/${groupId}/Device/Project`, {
        PageNo: devicePageNo,
        PageSize: devicePageSize,
        projectId: projectId
    });
    let data = result.data;
    mydeivdevice = [...mydeivdevice, ...data.data];
    data.data = mydeivdevice;
    if (devicePageNo < data.totalPage) {
        devicePageNo++;
        getProjectDevices(groupId, projectId, cb);
    } else {
        devicePageNo = 1;
        mydeivdevice = [];
        cb && cb(data);
    }
    return data;
}

/**
 * 添加视频监控
 * @param {string} groupId 组织的id
 * @param {string} DeviceSn 设备的编号
 * @param {object} data 参数
 * @returns {Promise<any>}
 */
export const addDeviceVideo = async (groupId, DeviceSn, data = {}) => {
    const result = await post(`api/${groupId}/${DeviceSn}/DeviceVideo`, data)
    let _data = result.data;
    return _data;
}

/**
 * 获取设备视频监控
 * @param {string} GroupId 
 * @param {string} DeviceSn 
 * @returns 
 */
export const getDeviceVideo = async (GroupId, DeviceSn) => {
    const result = await get(`api/${GroupId}/${DeviceSn}/DeviceVideo`)
    return result.data;
}

/**
 * 删除设备视频监控
 * @param {string} GroupId 
 * @param {string} DeviceSn 
 * @param {string} Id 
 * @returns 
 */
export const deleteDeviceVideo = async (GroupId, DeviceSn, Id) => {
    const result = await del(`api/${GroupId}/${DeviceSn}/DeviceVideo/${Id}`)
    return result.data;
}

/**
 * 编辑设备视频监控
 * @param {string} GroupId 
 * @param {string} DeviceSn 
 * @param {string} Id 
 * @returns 
 */
export const editDeviceVideo = async (GroupId, DeviceSn, data) => {
    const result = await put(`api/${GroupId}/${DeviceSn}/DeviceVideo`, { ...data })
    return result.data;
}

/**
 * 刷新设备视频监控
 * @param {string} GroupId 
 * @param {string} DeviceSn 
 * @param {string} Id 
 * @returns 
 */
export const reloadDeviceVideo = async (GroupId, DeviceSn, Id, data) => {
    const result = await put(`api/${GroupId}/${DeviceSn}/DeviceVideo/Refresh/${Id}`)
    return result.data;
}

/**
 * 获取设备的分类统计数据
 * @param {string} GroupId 
 * @param {string} projectId 
 * @returns 
 */
export const getOverView = async (GroupId, projectId) => {
    const result = await get(`api/${GroupId}/Device/OverView`, { projectId })
    return result.data;
}

/**
 * 搜索我的设备
 * @param {string} GroupId 
 * @param {string} Search 
 * @returns 
 */
export const getMyDevice = async (GroupId, Search) => {
    const result = await get(`api/${GroupId}/Device/MyDevice`, { Search })
    return result.data;
}

/**
 * 获取类型信息
 * @param {number} id 
 * @returns 
 */
export const getType = async (id)=>{
    const res = await get(`api/Type/${id}`,{cache:true},{cache:true})
    return res.data
}